import React, { useEffect, useState } from 'react'
import './ResidentialPlansReport.scss'
import { Button, Container, Grid, Select } from '@mui/material'
import { format, isValid, subDays } from 'date-fns'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import MenuItem from '@mui/material/MenuItem'
import CustomTable from '../../../Shared/CustomTable/CustomTable'
import ResidentialPlansReportActions from './ResidentialPlansReportActions'
import ResidentialPlanTypes from '../../../../Constants/ResidentialPlansTypes'
import { CSVLink } from 'react-csv'
import { BiDownload } from 'react-icons/bi'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import { useMenuSectionContext } from './../../MenuSection/MenuSectionContext'
import { AdapterDateFns as AdapterDateFnsV3 } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'

function ResidentialPlansReport() {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const menuSectionContext = useMenuSectionContext()
  const { setLastCustomSectionId } = menuSectionContext.actions
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [columns, setColumns] = useState([])
  const [residentialPlansReportEntity, setResidentialPlansReportEntity] = useState([])
  const [movementType, setMovementType] = useState(ResidentialPlanTypes.READ)
  const [data, setData] = useState([])
  const [posting, setPosting] = useState(false)
  const DATE_FORMAT_PATTERN = 'yyyy-MM-dd'

  Interceptor.interceptor(errorSnackBarActions)

  async function fetchResidentialPlansReport() {
    const payload = {
      movementType,
      startDate: format(startDate, DATE_FORMAT_PATTERN),
      endDate: format(endDate, DATE_FORMAT_PATTERN)
    }
    const response = await ResidentialPlansReportActions.getResidentialPlansReport(
      JSON.stringify(payload)
    )
    if (response) {
      const data = response
      const formatedData =
        data &&
        data.map((resPlan) => {
          const testObject = {}
          if (!resPlan.userAgencyName) {
            const userAgencyName = { userAgencyName: '' }
            Object.assign(testObject, userAgencyName)
          }
          if (!resPlan.residentialPlanAddress) {
            const residentialPlanAddressFormat = {
              residentialPlanAddress: {
                apartmentNumber: null,
                city: 'old one',
                country: 'Mexico',
                floor: null,
                multiUnitType: null,
                multiUnitTypeOther: null,
                state: 'old',
                streetName: 'old one',
                streetNumber: '1',
                unitNumber: null
              }
            }
            Object.assign(testObject, residentialPlanAddressFormat)
          }
          return Object.assign(resPlan, testObject)
        })
      setResidentialPlansReportEntity(formatedData)
    }
    setPosting(false)
  }

  useEffect(() => {
    // Substract one month to the current start date
    const startD = subDays(new Date(), 30)

    setStartDate(startD)
    setEndDate(new Date())
    setColumns([
      { id: 'dateFormatted', type: 'string', label: 'Logged Date' },
      { id: 'userName', type: 'string', label: 'Logged By' },
      { id: 'userAgencyName', type: 'string', label: 'User Entity' },
      { id: 'movement', type: 'string', label: 'Actions' },
      { id: 'owner', type: 'string', label: 'Property Owner' },
      { id: 'residentialPlanAddress', type: 'object', label: 'Property' },
      { id: 'sourceSystem', type: 'string', label: 'Logged System' }
    ])
  }, [])

  useEffect(() => {
    setLastCustomSectionId('')
    if (
      residentialPlansReportEntity &&
      Array.isArray(residentialPlansReportEntity) &&
      residentialPlansReportEntity.length > 0
    ) {
      setData(
        Array.isArray(residentialPlansReportEntity) && residentialPlansReportEntity.length > 0
          ? residentialPlansReportEntity.map((elem) => {
              return {
                dateFormatted: elem.dateFormatted,
                userName: elem.userName,
                owner: elem.owner,
                residentialPlanAddress: formatAddress(elem.residentialPlanAddress),
                movement: elem.movement,
                userAgencyName: elem.userAgencyName,
                sourceSystem: elem.sourceSystem
              }
            })
          : null
      )
    } else {
      setData([])
    }
  }, [residentialPlansReportEntity])

  const headers = [
    { label: 'Logged Date', key: 'dateFormatted' },
    { label: 'Logged By', key: 'userName' },
    { label: 'User Entity', key: 'userAgencyName' },
    { label: 'Actions', key: 'movement' },
    { label: 'Property Owner', key: 'owner' },
    { label: 'Property', key: 'residentialPlanAddress' },
    { label: 'Logged System', key: 'sourceSystem' }
  ]

  const setMultiFamilyUnit = (elem, isOther) => {
    switch (elem) {
      case 1:
        return 'Front'
      case 2:
        return 'Rear'
      case 3:
        return 'Left'
      case 4:
        return 'Right'
      case 5:
        return 'Middle Unit'
      case 6:
        return 'Basement Unit'
      case 7:
        return 'First Floor'
      case 8:
        return 'Second Floor'
      case 9:
        return `${isOther}`
      default:
        return ''
    }
  }

  const formatAddress = (address) => {
    if (address) {
      const addressFormat = `${address.streetNumber !== null ? `${address.streetNumber}, ` : ''}${
        address.streetName !== null ? `${address.streetName}, ` : ''
      }${
        address.multiUnitType && address.multiUnitType.length > 0
          ? address.multiUnitType
              .map((elem) => {
                const isOther = address.multiUnitTypeOther && address.multiUnitTypeOther
                return `${setMultiFamilyUnit(elem, isOther)}, `
              })
              .join('')
          : ''
      }${address.apartmentNumber !== null ? `Apartment: ${address.apartmentNumber}, ` : ''}${
        address.unitNumber !== null ? `Unit: ${address.unitNumber}, ` : ''
      }${address.floor !== null ? `Floor: ${address.floor}, ` : ''}${
        address.city !== null ? `${address.city}, ` : ''
      }${address.state !== null ? `${address.state}, ` : ''}${
        address.country !== null ? `${address.country}` : ''
      }`
      return addressFormat
    }
  }
  const getDatesBetweenDates = (startDate, endDate) => {
    let dates = []
    const theDate = new Date(startDate)
    while (theDate < endDate) {
      dates = [...dates, new Date(theDate)]
      theDate.setDate(theDate.getDate() + 1)
    }
    return dates.length
  }

  const search = () => {
    if (isUserInputsValid()) {
      const dateRange = getDatesBetweenDates(startDate, endDate)
      if (startDate.getTime() > endDate.getTime()) {
        showErrorSnack('Start Date cannot be greater than End Date')
        return
      }
      setPosting(true)

      if (dateRange > 30) {
        showErrorSnack('Please provide a search no longer than 30 days')
        setPosting(false)
        return
      }
      fetchResidentialPlansReport()
    }
  }

  const isUserInputsValid = () => {
    if (!isValid(startDate)) {
      showErrorSnack('Provide valid value for start date')
      return false
    }

    if (!isValid(endDate)) {
      showErrorSnack('Provide valid value for end date')
      return false
    }

    return true
  }

  const showErrorSnack = (errorMessage) => {
    errorSnackBarActions.setOpen(true, errorMessage, 'warning')
  }

  const handleStartDateChange = (date) => setStartDate(date)
  const handleEndDateChange = (date) => setEndDate(date)
  const movementTypeSelected = (e) =>
    setMovementType(e.target.value === 'all' ? [0, 1, 2, 3, 5] : [parseInt(e.target.value)])

  return (
    <div className="residential-plans-report">
      <div className="page-header">
        <span>Properties Report</span>
      </div>
      <Container maxWidth="lg">
        <Grid container className="controls" spacing={3}>
          <Grid container size={{ xs: 12 }} columnSpacing={2} className="controls-container">
            <Grid size={{ xs: 12, sm: 6, lg: 12 }}>
              {data && data.length > 0 ? (
                <div className="button-container">
                  <CSVLink
                    data={data}
                    headers={headers}
                    filename={'properties-report.csv'}
                    className="print-button"
                  >
                    Download
                    <BiDownload />
                  </CSVLink>
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 6, lg: 3 }} >
              <label htmlFor="status">Actions</label>
              <br />
              <Select
                id="status"
                variant="outlined"
                defaultValue={ResidentialPlanTypes.READ}
                className="actions-field"
                onChange={movementTypeSelected}
              >
                <MenuItem value={ResidentialPlanTypes.READ}>Read</MenuItem>
                <MenuItem value={ResidentialPlanTypes.ADD}>Add</MenuItem>
                <MenuItem value={ResidentialPlanTypes.EDIT}>Edit</MenuItem>
                <MenuItem value={ResidentialPlanTypes.DELETE}>Delete</MenuItem>
                <MenuItem value={ResidentialPlanTypes.APPROVE}>Approve</MenuItem>
              </Select>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
              <label htmlFor="startDate">Start Date</label>
              <br />
              <LocalizationProvider dateAdapter={AdapterDateFnsV3}>
                <DatePicker
                  id="startDate"
                  className="date-field"
                  disableFuture
                  format={DATE_FORMAT_PATTERN}
                  value={startDate}
                  onChange={handleStartDateChange}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
              <label htmlFor="endDate">End Date</label>
              <br />
              <LocalizationProvider dateAdapter={AdapterDateFnsV3}>
                <DatePicker
                  id="endDate"
                  className="date-field"
                  disableFuture
                  format={DATE_FORMAT_PATTERN}
                  value={endDate}
                  onChange={handleEndDateChange}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, lg: 3 }} sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <Button
                color="primary"
                size="medium"
                variant="contained"
                disabled={posting}
                onClick={search}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 12 }} className="table-container">
            {posting ? (
              <LoadingSpinner />
            ) : (
              <CustomTable
                data={residentialPlansReportEntity}
                dataStateSetter={setResidentialPlansReportEntity}
                columns={columns}
                tableSize="small"
                orderByDefaultProperty="movementDate"
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default ResidentialPlansReport
